module.exports = __webpack_public_path__ + "static/img/科大讯飞AI学习机T30 Ultra.bbf531e4.png";